<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    // 检测浏览器路由改变页面不刷新问题,hash模式的工作原理是hashchange事件
    window.addEventListener('hashchange', () => {
      const currentPath = window.location.hash.slice(1)
      if (this.$route.path !== currentPath) {
        this.$router.push(currentPath)
      }
    }, false)
  }
}
</script>

<style>
  /* 解决element-ui的table表格控件表头与内容列不对齐问题 */
  .el-table th.gutter{
    display: table-cell!important;
  }
  .el-table .cell {
    padding-left: 0px!important;padding-right: 0px!important;padding-top: 0px!important;padding-bottom: 0px!important;
  }

  /* 按开发者工具后会多出一条线 */
  .el-tabs__header {
    margin:0px
  }
  .el-table__fixed-right {
      height:100% !important;
  }
  .el-table__fixed {
      height:100% !important;
  }
  .el-table--border th.gutter:last-of-type { display: block!important; width: 17px!important; }

  .el-table__body-wrapper{z-index: 2}

  /* 去掉colum的内边距 */
  .el-table--enable-row-transition .el-table__body td{
    padding: 0px;
  }

</style>
